import { Button, Typography } from "@material-ui/core";
import clsx from "clsx";
import { useStyle } from "./schedule-footer.styles";

interface Props {
  sessionPoints?: number;
  onPurchaseSessionPoints?: () => void;
}

export default function ScheduleFooter({
  sessionPoints,
  onPurchaseSessionPoints,
}: Props) {
  const classes = useStyle();

  const handlePurchaseClick = () => {
    onPurchaseSessionPoints?.();
  };

  return (
    typeof sessionPoints === "number" && (
      <>
        <div className={classes.container}>
          <span
            className={clsx([
              classes.points,
              sessionPoints > 0
                ? classes.availablePoints
                : classes.unavailablePoints,
            ])}
          >
            {sessionPoints}
          </span>

          <Typography className={classes.text}>Session Points</Typography>
        </div>

        {sessionPoints < 1 && (
          <Button
            className={classes.purchaseButton}
            onClick={handlePurchaseClick}
          >
            <Typography className={classes.error}>
              Insufficient Session Points
            </Typography>

            <Typography className={classes.text}>
              Please <span className={classes.underline}>purchase more</span> to
              book a 1:1 session.
            </Typography>
          </Button>
        )}
      </>
    )
  );
}
